import { takeLatest, put, call } from "redux-saga/effects";
import { sagaActions } from "../../actions";
import {
  fetchHistoryRequests,
  fetchHistoryRequestsCompleted,
} from "../../slices/history_requests";
import { workflowsService } from "../../../../../src/core/workflows/workflows_service";

async function handleFetchHistoryRequests({ page, items }) {
  return await workflowsService.listHistoryRequests(page, items);
}

async function handleGetUsers({ tokens, page, items, filters }) {
  return await workflowsService.listUsers(tokens, page, items, filters);
}

function* listHistoryRequestsSaga({ payload }) {
  try {
    yield put(fetchHistoryRequests());
    const historyRequestsData = yield call(handleFetchHistoryRequests, payload);
    const usersTokens = historyRequestsData.data.map((item) => item.user_token);
    const { data: usersData } = yield call(handleGetUsers, {
      tokens: usersTokens,
      page: 1,
      items: 10,
      filters: {},
    });

    historyRequestsData.data = historyRequestsData.data.map((item) => {
      const user = usersData.find((user) => user.token === item.user_token);
      return {
        ...item,
        fullName: `${user.name} ${user.last_name}`,
      };
    });
    yield put(fetchHistoryRequestsCompleted(historyRequestsData));
  } catch (error) {
    console.error(error.message);
  }
}

export function* listHistoryRequestsWatcherSaga() {
  yield takeLatest(
    sagaActions.START_FETCH_LIST_HISTORY_REQUESTS,
    listHistoryRequestsSaga
  );
}
